export const SET_LOADING_DATA = '@vendorClientVisit/SET_LOADING_DATA';
export const SET_LOADING_SELECTS = '@vendorClientVisit/SET_LOADING_SELECTS';

export const GET_LIST_ALL_REQUEST = '@vendorClientVisit/GET_LIST_ALL_REQUEST';
export const GET_LIST_ALL_SUCCESS = '@vendorClientVisit/GET_LIST_ALL_SUCCESS';

export const GET_LIST_SELECTS_REQUEST = '@vendorClientVisit/GET_LIST_SELECTS_REQUEST';
export const GET_LIST_SELECTS_SUCCESS = '@vendorClientVisit/GET_LIST_SELECTS_SUCCESS';

export const SHARE_CSV = '@vendorClientVisit/SHARE_CSV';

export const SET_PAGE = '@vendorClientVisit/SET_PAGE';
export const SET_ROWS_COUNT = '@vendorClientVisit/SET_ROWS_COUNT';
export const SET_ROWS_PER_PAGE = '@vendorClientVisit/SET_ROWS_PER_PAGE';
export const SET_ORDER = '@vendorClientVisit/SET_ORDER';
export const SET_ORDERBY = '@vendorClientVisit/SET_ORDERBY';
